<template>
  <div class="form-static-text form-item">
    <div class="widget-item" :class="renderSence === 'edit' ? 'widget-item-border' : ''">
      <pre :style="{ color: widget.textColor }">{{ widget.staticDefaultValue }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormStaticText',
  props: {
    widget: {
      type: Object,
      required: true
    },
    renderSence: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.form-static-text {
  .widget-item {
    padding: 0.857rem 1.143rem;
    background-color: $--app-light-color;
    line-height: 1.286rem;
    pre {
      white-space: pre-wrap;
      word-wrap: break-word;
      margin: 0 !important;
      background-color: rgba(255, 255, 255, 0) !important;
      padding: 0 !important;
    }
  }
  .widget-item-border {
    border-bottom: 1PX solid $--app-body-bgColor;
  }
}
</style>